import { render, staticRenderFns } from "./SaveDocumentRow.vue?vue&type=template&id=d47b1726"
import script from "./SaveDocumentRow.vue?vue&type=script&lang=js"
export * from "./SaveDocumentRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports